// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardGridLayoutUIStore.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!(function() {
  var GridLayoutUIStore = require('share/components/controls/GridLayout/Izenda.GridLayoutUIStore');
  var GridItemState = require('share/components/controls/GridLayout/Izenda.GridItemState');
  var Constants = require('logic/data/Izenda.DashboardGridConstants');
  var UiState = require('logic/Izenda.UiState');
  const { create, floor } = require('lodash/fp');
  var action = require('mobx').action;
  var extendObservable = require('mobx').extendObservable;

  function DashboardGridLayoutUIStore(width, transparent, calcContainerHeight) {
    GridLayoutUIStore.call(
      this,
      Constants.GRID_CELL_SIZE, // default grid cell width
      Constants.GRID_CELL_SIZE, // default grid cell height
      width, // dashboard grid width
      Constants.NUMBER_ROWS, // dashboard grid layout rows
      Constants.NUMBER_COLS,
      true, // allow infinity rows
      false, // allow infinity cols
      true, // view in full size mode
      true,
      null,
      null,
      Constants.TILE_MAX_HEIGHT
    );
    extendObservable(this, {
      transparent: !!transparent,
      readOnlyMode: false,
      hasDashboardPart: true,
      leftPadding: 0,
      rightPadding: 0
    });
    this.calcContainerHeight = calcContainerHeight;
  }

  DashboardGridLayoutUIStore.prototype = create(GridLayoutUIStore.prototype, {
    constructor: DashboardGridLayoutUIStore
  });

  DashboardGridLayoutUIStore.prototype.setViewWidth = action(function setViewWidth(width) {
    const newCellSize = floor(width / this.cols);
    this.cellWidth = newCellSize;
    this.cellHeight = newCellSize;

    // left/right padding used to align grid
    const difference = Math.round(((width / this.cols) - newCellSize) * 12);
    this.leftPadding = Math.floor(difference / 2);
    this.rightPadding = difference - this.leftPadding;
    GridLayoutUIStore.prototype.setViewWidth.call(this, width);

    this.recalculateLayoutPosition();
  });

  DashboardGridLayoutUIStore.prototype.setTransparent = action(function(transparent) {
    this.transparent = !!transparent;
  });

  DashboardGridLayoutUIStore.prototype.setReadonlyMode = action(function(hasDashboardPart) {
    this.readOnlyMode = true;
    this.hasDashboardPart = hasDashboardPart;
  });

  DashboardGridLayoutUIStore.prototype.calcHeight = function() {
    // return this.readOnlyMode ? 0 : GridLayoutUIStore.prototype.calcHeight.call(this);
    return GridLayoutUIStore.prototype.calcHeight.call(this);
  };

  DashboardGridLayoutUIStore.prototype.calcActualGridSize = function() {
    var size = GridLayoutUIStore.prototype.calcActualGridSize.call(this);
    if (this.readOnlyMode) {
      var gridLineActualHeight = this.hasDashboardPart ? size.height - this.cellHeight : this.cellHeight;
      var gridLineFitHeight = this.calcContainerHeight ? this.calcContainerHeight() : 0;
      size.height = Math.max(gridLineFitHeight, gridLineActualHeight);
    }
    return size;
  };

  module.exports = DashboardGridLayoutUIStore;
})();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/Izenda.DashboardGridLayoutUIStore.js